import React from 'react';
import Whapi from './pages/Whapi';
import { Box, useTheme } from '@mui/material';
import { WhapiProvider } from 'context';
import BrightModeToggle from 'components/BrightModeToggle';

function App() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: '100vw',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.mode === 'light' ? 'rgba(255, 254, 216, 0.5)' : 'rgb(2, 0, 27)',
      }}
    >
      <Box sx={{ position: 'absolute', top: '20px', right: '20px' }}>
        <BrightModeToggle />
      </Box>
      <WhapiProvider>
        <Whapi />
      </WhapiProvider>
    </Box>
  );
}

export default App;
